import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function TotalSummaryIconItems(props) {
  const { icon, title, message, bgColor, sx } = props;

  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={{ ...sx }}>
      <Box
        sx={{
          bgcolor: bgColor,
          borderRadius: '10px',
          p: 1,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography variant="caption" display="block" gutterBottom>
          {title}
        </Typography>
        <span>{message}</span>
      </Box>
    </Stack>
  );
}
